module.exports = __webpack_public_path__ + "static/img/callcenterHSD.81e9192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callcenterHSD.jpg
// module id = Rb+6
// module chunks = 2